import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.incidents'),
    id: 'incidents',
    sidebar: [
        {
            id: 'incidentOrigins',
            label: i18n.tc('configuration.sections.incidentOrigins', 2),
            icon: 'far fa-map-marker-exclamation',
            routeName: 'IncidentOrigins',
            hasChildren: false
        },
        {
            id: 'incidentTypes',
            label: i18n.tc('configuration.sections.incidentTypes', 2),
            icon: 'fal fa-list-ul',
            routeName: 'IncidentTypes',
            hasChildren: false
        }
    ]
}
